module.exports = __webpack_public_path__ + "media/images/ir/profile/photo_hamasaki-c9ba771b7a78c99f461c75d024822a3f.jpg";